import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { motion } from "framer-motion";
import checkImg from "../../Components/Assets/images/checkimg.jpg";
import wrongImg from "../../Components/Assets/images/wrongimg.jpg";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useState } from "react";

const EmailTable = ({ email, loading, handleEditData }) => {
  const isMobile = useMediaQuery("(max-width: 768px)"); // ✅ Mobile View Check
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll for better UX
    });
  };

  const [visiblePasswords, setVisiblePasswords] = useState({});

  const togglePasswordVisibility = (id) => {
    setVisiblePasswords((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div>
      {/* ✅ Desktop View - Table */}
      {!isMobile ? (
        <TableContainer component={Paper} elevation={3}>
          <Table>
            {/* Table Header */}
            <TableHead sx={{ backgroundColor: "skyblue" }}>
              <TableRow>
                <TableCell sx={{ color: "white" }}>S.No</TableCell>
                <TableCell sx={{ color: "white" }}>Username</TableCell>
                <TableCell sx={{ color: "white" }}>Password</TableCell>
                <TableCell sx={{ color: "white" }}>From Address</TableCell>
                <TableCell sx={{ color: "white" }}>From Name</TableCell>
                <TableCell sx={{ color: "white" }}>Mailer</TableCell>
                <TableCell sx={{ color: "white" }}>Host</TableCell>
                <TableCell sx={{ color: "white" }}>Port</TableCell>
                <TableCell sx={{ color: "white" }}>Encryption</TableCell>
                <TableCell sx={{ color: "white" }}>Status</TableCell>
                <TableCell sx={{ color: "white" }}>Actions</TableCell>
              </TableRow>
            </TableHead>

            {/* Table Body */}
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : email?.length > 0 ? (
                email.map((row, index) => (
                  <motion.tr
                    key={row.id}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#e0e0e0",
                    }}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.mail_username}</TableCell>
                    <TableCell>
                      {visiblePasswords[row.id] ? row.mail_password : "****"}
                      <IconButton
                        onClick={() => togglePasswordVisibility(row.id)}
                      >
                        {visiblePasswords[row.id] ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </TableCell>

                    <TableCell>{row.mail_from_address}</TableCell>
                    <TableCell>{row.mail_from_name}</TableCell>
                    <TableCell>{row.mail_mailer}</TableCell>
                    <TableCell>{row.mail_host}</TableCell>
                    <TableCell>{row.mail_port}</TableCell>
                    <TableCell>{row.mail_encryption}</TableCell>

                    <TableCell>
                      <img
                        src={row.status ? checkImg : wrongImg}
                        alt={row.status ? "Active" : "Inactive"}
                        style={{ width: "20px", height: "20px" }}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        title="Edit"
                        onClick={() => {
                          scrollToTop();
                          handleEditData(row);
                        }}
                        style={{ color: "blue" }}
                      >
                        <Edit />
                      </IconButton>
                    </TableCell>
                  </motion.tr>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={7}
                    align="center"
                    sx={{ color: "red", fontWeight: "bold" }}
                  >
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        // ✅ Mobile View - Box Layout
        <div>
          {loading ? (
            <CircularProgress sx={{ display: "block", margin: "20px auto" }} />
          ) : email?.length > 0 ? (
            email.map((row, index) => (
              <motion.div
                key={row.id}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#e0e0e0",
                  padding: "10px",
                  margin: "10px 0",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                <p>
                  <strong>S.No:</strong> {index + 1}
                </p>
                <p>
                  <strong>Username:</strong> {row.mail_username}
                </p>
                <p>
                  <strong>Password:</strong> {row.mail_password}
                </p>
                <p>
                  <strong>From Address:</strong> {row.mail_from_address}
                </p>
                <p>
                  <strong>From Name:</strong> {row.mail_from_name}
                </p>
                <p>
                  <strong>Mailer Name:</strong> {row.mail_mailer}
                </p>
                <p>
                  <strong>Host Name:</strong> {row.mail_host}
                </p>
                <p>
                  <strong>Port Name:</strong> {row.mail_port}
                </p>
                <p>
                  <strong>Encryption Name:</strong> {row.mail_encryption}
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  <img
                    src={row.status ? checkImg : wrongImg}
                    alt={row.status ? "Active" : "Inactive"}
                    style={{ width: "20px", height: "20px" }}
                  />
                </p>
                <IconButton
                  title="Edit"
                  onClick={() => {
                    handleEditData(row);
                    scrollToTop();
                  }}
                  style={{ color: "blue" }}
                >
                  <Edit />
                </IconButton>
              </motion.div>
            ))
          ) : (
            <p
              style={{
                textAlign: "center",
                color: "red",
                fontWeight: "bold",
                marginTop: "20px",
              }}
            >
              No Data Found
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default EmailTable;
